import { render, staticRenderFns } from "./CheckBoxModal.vue?vue&type=template&id=6936d74e&scoped=true"
import script from "./CheckBoxModal.vue?vue&type=script&lang=js"
export * from "./CheckBoxModal.vue?vue&type=script&lang=js"
import style0 from "./CheckBoxModal.vue?vue&type=style&index=0&id=6936d74e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936d74e",
  null
  
)

export default component.exports